import clsx from 'clsx';
import * as React from 'react';
import { observer } from 'mobx-react';
import Navigation from '../../Edit/CurrentCollectionStep/Navigation';
import Button from '../../../../Form/Button';
import LearningCollectionStore from '../../Store';
import ChooseProductLicenseState from './ChooseProductLicenseState';
import { isNothing } from 'maybeasy';

interface Props {
  store: LearningCollectionStore;
}

const ChooseProductLicense: React.FC<Props> = ({ store }) => {
  return (
    <div>
      <Navigation store={store}>
        <Button
          type="button"
          value="Continue"
          className={clsx(
            'rounded-md bg-green-600 px-5 py-2.5 text-sm font-semibold text-white',
            'disabled:opacity-75',
          )}
          disabled={isNothing(store.selectedProductLicense)}
          onClick={store.reloadAllExperiences}
        />
      </Navigation>
      <ChooseProductLicenseState store={store} />
    </div>
  );
};

export default observer(ChooseProductLicense);
